import React, { useState } from 'react';
import { useTheme } from 'styled-components';

import {
  Nav,
  NavUser,
  Box,
  Icon,
  Container,
  Title,
  Subtitle,
  CompleteCircle,
} from './styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Popover from '../Popover';
import { useSelector } from 'react-redux';
import format from '../../services/utils/formatCPFandCNPJ';

function NavBar() {
  const [open, setOpen] = useState(false);

  const user = useSelector((state: ApplicationState) => {
    return {
      name: state.auth.user?.nome,
      cpf: state.auth.user?.cpf || state.auth.cpf,
      page: state.auth.page,
    };
  });

  const theme = useTheme();
  const percentage = useSelector(
    (state: ApplicationState) => state.auth.percentage
  );

  const handlerPopover = () => {
    setOpen(!open);
  };

  return (
    <>
      <Nav>
        <NavUser onClick={handlerPopover}>
          <div style={{ height: 36, width: 1, background: '#DFE4EF' }}></div>
          <Box>
            {percentage !== 100 ? (
              <CircularProgressbar
                value={percentage}
                strokeWidth={15}
                styles={buildStyles({
                  pathColor: theme.colors.primary,
                  trailColor: theme.colors.primaryLight,
                })}
              />
            ) : (
              <CompleteCircle>100%</CompleteCircle>
            )}
          </Box>
          <Container>
            <Title> Olá, {user.name}</Title>
            <Subtitle>
              CPF: {user.cpf?.length >= 11 ? format(user.cpf) : user.cpf}
            </Subtitle>
          </Container>
          <Icon>
            <FontAwesomeIcon icon={faChevronDown} />
          </Icon>
        </NavUser>
        <Popover open={open} close={() => setOpen(false)} />
      </Nav>
    </>
  );
}

export default NavBar;
